var _path, _polygon, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerloginPana1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.72,207.65l1.52,2.21c12.79,18.6,34.59,29,56.79,26.32a59.66,59.66,0,0,0,8.46-1.66c20-5.5,36.77-21.82,43-41.86,3.64-11.79,4.08-25.14,11.71-34.77,9.94-12.53,27.93-13.93,43.8-14.34s33.88-1.87,43.76-14.44c6.19-7.87,7.68-18.65,6.57-28.66-2.93-26.49-22.81-49.2-47-59.66s-52-9.94-77.49-3.27C100.07,46.86,66.87,68.81,48,100.86S26.3,175.28,44.72,207.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626.17,
    cy: 121.27,
    r: 68.2,
    transform: "translate(408.18 720.67) rotate(-80.98)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.81,459.13c0,.14-149.83.26-334.61.26s-334.63-.12-334.63-.26,149.79-.26,334.63-.26S712.81,459,712.81,459.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.9,454h-421a25.2,25.2,0,0,1-25.2-25.2V139.91a18.38,18.38,0,0,1,18.38-18.38H599.73A17.37,17.37,0,0,1,617.1,138.9V428.82A25.2,25.2,0,0,1,591.9,454Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.9,454l1-.07,1.27-.07c.5,0,1.08-.15,1.74-.24l1.06-.16,1.15-.3,1.26-.33,1.34-.5a23.54,23.54,0,0,0,2.93-1.31c.51-.25,1-.59,1.53-.9l.8-.49.77-.58a24.77,24.77,0,0,0,9.87-16c.07-.48.14-.95.22-1.43s.06-1,.09-1.47c.07-1,.08-2,.07-3q0-3.08,0-6.39,0-6.6,0-14.06c0-39.74,0-97.25-.09-168.31q0-26.64,0-55.77,0-14.53,0-29.66V141.51c0-1.27,0-2.57-.07-3.82a17.13,17.13,0,0,0-7.33-12.89,16.93,16.93,0,0,0-7.16-2.83c-.32,0-.64-.11-1-.14l-1,0c-.65,0-1.31,0-2,0H476.85l-305.66,0h-5.08c-.84,0-1.7,0-2.53,0l-1.24.06c-.42.05-.83.12-1.24.18a7.34,7.34,0,0,0-1.22.25c-.41.11-.81.2-1.21.32a18.57,18.57,0,0,0-2.31.93,17.4,17.4,0,0,0-4.15,2.72A17.65,17.65,0,0,0,149,130a19.08,19.08,0,0,0-2.12,4.47,18.79,18.79,0,0,0-.8,4.88c-.05,1.66,0,3.35,0,5V262.28c0,51.13,0,100.45,0,147.43v17.51c0,1.45.05,2.88.15,4.31l.32,2.12c.14.7.35,1.38.52,2.08a25.23,25.23,0,0,0,3.7,7.63,24.85,24.85,0,0,0,13.58,9.49c.68.16,1.34.39,2,.49l2.07.31c1.39.08,2.78.17,4.18.14h73.14l116.23,0,168.29.08L576,454l11.9,0,4,0-4,0-11.9,0-45.76.05-168.29.08-116.23,0H172.53c-1.39,0-2.81-.06-4.23-.14l-2.1-.32c-.71-.1-1.38-.33-2.08-.49a25.33,25.33,0,0,1-13.83-9.67,25.83,25.83,0,0,1-3.78-7.77c-.17-.71-.38-1.41-.52-2.12l-.33-2.16c-.1-1.45-.18-2.92-.15-4.36q0-8.7,0-17.51c0-47,0-96.3,0-147.43q0-38.35,0-78V144.4c0-1.68,0-3.34,0-5a19.37,19.37,0,0,1,.82-5,20.06,20.06,0,0,1,2.18-4.61,18.92,18.92,0,0,1,3.35-3.85,18.1,18.1,0,0,1,4.27-2.8,20.4,20.4,0,0,1,2.38-1c.41-.12.83-.21,1.25-.32a7.71,7.71,0,0,1,1.25-.26c.43-.06.85-.14,1.27-.19l1.29-.06c.86-.06,1.69,0,2.54,0h5.08l305.66,0H598.42c.66,0,1.32,0,2,0l1,.05c.33,0,.66.09,1,.14a17.17,17.17,0,0,1,7.33,2.91,17.55,17.55,0,0,1,7.52,13.21c.09,1.3,0,2.57.06,3.85v11.42q0,15.12,0,29.66,0,29.1,0,55.77c0,71.06-.06,128.57-.08,168.31q0,7.45,0,14.06c0,2.21,0,4.34,0,6.39,0,1,0,2-.07,3,0,.5,0,1-.1,1.48s-.15,1-.22,1.43a24.91,24.91,0,0,1-10,16.08l-.77.58-.8.49c-.54.31-1,.65-1.55.91a26.85,26.85,0,0,1-2.94,1.3l-1.35.49-1.27.32-1.15.29-1.06.16a17.31,17.31,0,0,1-1.75.23l-1.27.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,459.08H150.39A24.36,24.36,0,0,1,126,434.72v-3.79A.94.94,0,0,1,127,430h508.8a.94.94,0,0,1,.94.94V439A20.1,20.1,0,0,1,616.61,459.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,459.08l.68-.05a14.87,14.87,0,0,0,2-.18,19.08,19.08,0,0,0,7.5-2.65,19.34,19.34,0,0,0,4.55-3.71,20.2,20.2,0,0,0,3.78-6,20.82,20.82,0,0,0,1.46-8.11c0-1.49,0-3,0-4.6v-2.41c0-.41,0-.82-.27-1.07s-.69-.22-1.11-.23l-113.55.08-374.61.08H127a.78.78,0,0,0-.31.05.68.68,0,0,0-.38.45,4.65,4.65,0,0,0,0,.78v1.7c0,1.13,0,2.25.1,3.37a22.92,22.92,0,0,0,1.43,6.5,25.93,25.93,0,0,0,1.35,3A27.22,27.22,0,0,0,131,449,24.24,24.24,0,0,0,141.28,457a25.5,25.5,0,0,0,6.37,1.63c2.17.21,4.39.16,6.6.16H293l168.41.06L575,459l30.87,0,8,0,2.74,0-2.74,0-8,0-30.87.05-113.54.09L293,459.32l-99.46,0H154.25c-2.2,0-4.42,0-6.66-.17a25.74,25.74,0,0,1-6.51-1.66,24.77,24.77,0,0,1-10.53-8.25,26.76,26.76,0,0,1-1.84-2.86,29.72,29.72,0,0,1-1.38-3.11,23.71,23.71,0,0,1-1.46-6.65c-.07-1.14-.12-2.28-.1-3.41v-1.7a4.92,4.92,0,0,1,0-.91,1.22,1.22,0,0,1,1.2-.89h20.06l374.61.08,113.55.08h.63a1,1,0,0,1,.62.28,1,1,0,0,1,.31.59c0,.24,0,.42,0,.63,0,.81,0,1.62,0,2.41v4.6a20.94,20.94,0,0,1-1.5,8.17,20,20,0,0,1-3.83,6,20.06,20.06,0,0,1-12.14,6.33,14.18,14.18,0,0,1-2,.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.06,
    y: 141.83,
    width: 431.39,
    height: 272.36,
    rx: 5.25,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.21,414.19s.31,0,.9-.1a5.36,5.36,0,0,0,2.42-1.12,5.2,5.2,0,0,0,1.88-3.85q0-2.65,0-6.15c0-9.32,0-23.05,0-40.75,0-35.38-.05-86.58-.09-149.85q0-23.73,0-49.66,0-6.47,0-13.08V148a10.77,10.77,0,0,0-.06-1.62,5,5,0,0,0-1.39-2.82,5.08,5.08,0,0,0-2.8-1.44,9.88,9.88,0,0,0-1.64-.06h-29.1l-118.77,0-272.15,0a5,5,0,0,0-3.79,1.72,4.82,4.82,0,0,0-1,1.87,7,7,0,0,0-.2,2.16V279.75q0,34.14,0,67v60.32a9.44,9.44,0,0,0,.38,3.78,5,5,0,0,0,2.54,2.62,4.91,4.91,0,0,0,1.8.44c.62,0,1.29,0,1.94,0h111l103.49,0,149.85.08,40.74.05,10.59,0,3.61,0-3.61,0-10.59,0-40.74.05-149.85.08-103.49,0-57.65,0H172c-.66,0-1.29,0-2,0a5.64,5.64,0,0,1-2-.48,5.56,5.56,0,0,1-2.78-2.87,5.31,5.31,0,0,1-.42-2V346.77q0-32.85,0-67V210.31q0-17.64,0-35.52V147.84a7.66,7.66,0,0,1,.23-2.31,5.15,5.15,0,0,1,1.13-2.06,5.5,5.5,0,0,1,4.18-1.9l272.15,0,118.77,0h29.1a9.79,9.79,0,0,1,1.7.07,5.54,5.54,0,0,1,3,1.56,5.42,5.42,0,0,1,1.5,3.05,10.61,10.61,0,0,1,.06,1.68v14.73q0,25.9,0,49.66c0,63.27-.06,114.47-.08,149.85,0,17.7,0,31.43,0,40.75q0,3.5,0,6.15a5.27,5.27,0,0,1-1.93,3.89,5.2,5.2,0,0,1-2.44,1.11,4.13,4.13,0,0,1-.68.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.95 429.43 341.29 440.18 430.46 440.18 436.35 429.43 334.95 429.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.91,132.61a3.54,3.54,0,1,1-3.54-3.54A3.54,3.54,0,0,1,384.91,132.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.68,
    y: 275.39,
    width: 137.09,
    height: 23.68,
    rx: 1.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.81,
    y: 307.92,
    width: 137.09,
    height: 23.68,
    rx: 1.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.07,287.08V284h.78V287c0,1.22.56,1.76,1.54,1.76s1.55-.54,1.55-1.76V284h.76v3.11a2.32,2.32,0,1,1-4.63,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.67,289l.31-.6a2.68,2.68,0,0,0,1.46.43c.69,0,1-.21,1-.56,0-.93-2.62-.12-2.62-1.77,0-.74.67-1.24,1.73-1.24a3.07,3.07,0,0,1,1.51.37l-.32.59a2.19,2.19,0,0,0-1.2-.32c-.65,0-1,.24-1,.57,0,1,2.62.18,2.62,1.79,0,.75-.69,1.22-1.79,1.22A3,3,0,0,1,327.67,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.84,287.61h-3.36a1.4,1.4,0,0,0,1.5,1.22,1.55,1.55,0,0,0,1.19-.5l.42.48a2.26,2.26,0,0,1-3.86-1.45,2,2,0,0,1,2.08-2.1,2,2,0,0,1,2,2.13A1.7,1.7,0,0,1,335.84,287.61Zm-3.36-.53h2.65a1.33,1.33,0,0,0-2.65,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.12,285.26V286H339a1.24,1.24,0,0,0-1.3,1.4v2.07h-.75v-4.15h.72v.7A1.57,1.57,0,0,1,339.12,285.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,287.05v2.39h-.75v-2.3c0-.81-.41-1.21-1.12-1.21a1.22,1.22,0,0,0-1.31,1.37v2.14h-.75v-4.15h.72v.63a1.76,1.76,0,0,1,1.49-.66A1.6,1.6,0,0,1,344,287.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.65,286.94v2.5h-.71v-.55a1.55,1.55,0,0,1-1.36.59c-.93,0-1.53-.5-1.53-1.22s.43-1.21,1.67-1.21h1.18v-.15c0-.63-.36-1-1.11-1a2.11,2.11,0,0,0-1.31.45l-.31-.56a2.72,2.72,0,0,1,1.71-.53C348,285.26,348.65,285.8,348.65,286.94Zm-.75,1.23v-.58h-1.15c-.74,0-1,.29-1,.64s.35.67.92.67A1.18,1.18,0,0,0,347.9,288.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,287.05v2.39h-.75v-2.3c0-.81-.39-1.21-1.07-1.21a1.2,1.2,0,0,0-1.24,1.37v2.14h-.75v-2.3c0-.81-.39-1.21-1.07-1.21a1.2,1.2,0,0,0-1.24,1.37v2.14h-.75v-4.15h.72v.62a1.66,1.66,0,0,1,1.43-.65,1.53,1.53,0,0,1,1.43.76,1.88,1.88,0,0,1,1.6-.76A1.58,1.58,0,0,1,356.92,287.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06,287.61H358.7a1.41,1.41,0,0,0,1.5,1.22,1.58,1.58,0,0,0,1.2-.5l.41.48a2.26,2.26,0,0,1-3.86-1.45,2,2,0,0,1,2.08-2.1,2,2,0,0,1,2.05,2.13A1.8,1.8,0,0,1,362.06,287.61Zm-3.36-.53h2.66a1.34,1.34,0,0,0-2.66,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.03,
    y: 344.6,
    width: 137.09,
    height: 23.68,
    rx: 1.45,
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.19,353.88h1.55v4.25h2.62v1.23h-4.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.61,357.23a2.4,2.4,0,1,1,2.4,2.2A2.22,2.22,0,0,1,373.61,357.23Zm3.29,0a.89.89,0,0,0-.89-1,1,1,0,0,0,0,2A.89.89,0,0,0,376.9,357.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.65,355.11v3.47c0,1.61-.91,2.36-2.49,2.36a3.69,3.69,0,0,1-2.1-.55l.54-1a2.46,2.46,0,0,0,1.43.45c.8,0,1.13-.36,1.13-1v-.14a1.59,1.59,0,0,1-1.26.5,2.05,2.05,0,1,1,0-4.1,1.52,1.52,0,0,1,1.33.59v-.52Zm-1.47,2a.86.86,0,0,0-.92-.86.87.87,0,1,0,0,1.73A.86.86,0,0,0,382.18,357.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,353.88h1.55v5.48H387Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,356.93v2.43h-1.49v-2.19c0-.61-.27-.87-.7-.87s-.84.3-.84,1v2.06h-1.49v-4.25H391v.46a1.81,1.81,0,0,1,1.34-.53A1.66,1.66,0,0,1,394.05,356.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.49,319.9a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,323.49,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,319.9a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,330,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.45,319.9a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,336.45,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.93,319.9a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,342.93,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.42,319.9a2.07,2.07,0,1,1-2.07-2.06A2.07,2.07,0,0,1,349.42,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,319.9a2.07,2.07,0,1,1-2.06-2.06A2.06,2.06,0,0,1,355.9,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.38,319.9a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,362.38,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.86,319.9a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,368.86,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.22,318.4h-.54v-.76a2.56,2.56,0,0,0-5.11,0v.76h-.77a.94.94,0,0,0-.94.94v4.15a.94.94,0,0,0,.94.94h6.42a.94.94,0,0,0,.94-.94v-4.15A.94.94,0,0,0,439.22,318.4ZM437,323.08H435l.5-1.27a1.06,1.06,0,1,1,.92,0Zm.92-4.68h-3.55v-.76a1.78,1.78,0,0,1,3.55,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.92,
    cy: 211.56,
    r: 35.74,
    transform: "translate(111.68 554.16) rotate(-80.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.66,211.56s0-.19-.06-.57-.06-1-.11-1.7c0-.37-.05-.79-.07-1.25s-.15-.95-.23-1.49a24.91,24.91,0,0,0-.75-3.69,33.89,33.89,0,0,0-4-9.47,35.68,35.68,0,0,0-24-16.72,32.8,32.8,0,0,0-4.49-.52c-.76,0-1.53-.1-2.31-.09l-2.35.12c-.4,0-.79,0-1.19.08l-1.18.18c-.79.13-1.6.23-2.39.39a39.3,39.3,0,0,0-4.74,1.39,36.28,36.28,0,0,0-4.62,2c-.75.4-1.47.88-2.21,1.32a18.16,18.16,0,0,0-2.15,1.47,33,33,0,0,0-7.5,7.54,34.24,34.24,0,0,0-5.07,9.77,35.19,35.19,0,0,0,0,22.4l1,2.63,1.2,2.5a10.88,10.88,0,0,0,.66,1.21l.72,1.18.71,1.16.82,1.1a39.34,39.34,0,0,0,3.48,4.11,40.4,40.4,0,0,0,4,3.42,19,19,0,0,0,2.14,1.48c.75.44,1.47.92,2.21,1.32a37,37,0,0,0,4.63,2,39.3,39.3,0,0,0,4.74,1.39c.79.16,1.6.25,2.39.39l1.18.18c.4,0,.79,0,1.19.08l2.35.12c.78,0,1.55-.07,2.31-.09a33.13,33.13,0,0,0,4.5-.52,35.69,35.69,0,0,0,24-16.72,34.13,34.13,0,0,0,4-9.47,24.91,24.91,0,0,0,.75-3.69c.08-.54.18-1,.23-1.49s.05-.88.07-1.25c.05-.73.09-1.3.11-1.7s.06-.58.06-.58,0,.2,0,.58,0,1-.06,1.71c0,.37,0,.79-.05,1.25s-.14,1-.21,1.5a24.46,24.46,0,0,1-.7,3.71,33.75,33.75,0,0,1-3.91,9.58,35.87,35.87,0,0,1-24.17,17,32.32,32.32,0,0,1-4.55.54c-.78,0-1.56.11-2.34.1l-2.38-.12c-.4,0-.81,0-1.21-.07l-1.2-.18c-.8-.14-1.61-.23-2.42-.39a39.21,39.21,0,0,1-9.5-3.46c-.76-.41-1.49-.89-2.24-1.33a17.83,17.83,0,0,1-2.17-1.5,39.21,39.21,0,0,1-4.09-3.46,40.48,40.48,0,0,1-3.53-4.17l-.83-1.11-.73-1.18-.72-1.19a9.77,9.77,0,0,1-.67-1.23l-1.23-2.54c-.32-.89-.65-1.78-1-2.67a35.71,35.71,0,0,1,0-22.72,34.6,34.6,0,0,1,5.15-9.91,41.78,41.78,0,0,1,3.53-4.17,40.57,40.57,0,0,1,4.09-3.47,19,19,0,0,1,2.17-1.49c.75-.44,1.48-.92,2.24-1.33a39.21,39.21,0,0,1,9.5-3.46c.81-.16,1.62-.25,2.42-.39l1.2-.18c.4-.05.81-.05,1.2-.07l2.38-.12c.79,0,1.57.07,2.35.1a33.53,33.53,0,0,1,4.54.53,36,36,0,0,1,24.18,17,34.12,34.12,0,0,1,3.91,9.57,24.57,24.57,0,0,1,.7,3.72c.07.54.16,1,.21,1.5s0,.88.05,1.25c0,.74,0,1.3.06,1.71S416.66,211.56,416.66,211.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.47,212.09a8.18,8.18,0,1,0-6,0c-12.57,1.78-12,14.61-12,14.61l29.73.13S396.93,213.86,384.47,212.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.9,384.26h-4.29a1.23,1.23,0,0,1-1.23-1.23v-4.29a1.23,1.23,0,0,1,1.23-1.23h4.29a1.24,1.24,0,0,1,1.23,1.23V383A1.24,1.24,0,0,1,317.9,384.26ZM313.61,378a.73.73,0,0,0-.73.73V383a.73.73,0,0,0,.73.73h4.29a.73.73,0,0,0,.73-.73v-4.29a.73.73,0,0,0-.73-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.11,383.34l-.89-1.27h-1.14v1.26h-.8V379h1.77c1.14,0,1.85.58,1.85,1.54a1.39,1.39,0,0,1-.92,1.37l1,1.42ZM325,379.69h-.94v1.73H325c.7,0,1.07-.32,1.07-.87S325.72,379.69,325,379.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.81,381.94h-2.59a1,1,0,0,0,1.07.79,1.17,1.17,0,0,0,.89-.36l.42.47a1.76,1.76,0,1,1-1.45-2.84,1.61,1.61,0,0,1,1.67,1.71C330.82,381.77,330.81,381.86,330.81,381.94Zm-2.6-.52h1.88a1,1,0,0,0-1.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.08,381.45v1.89h-.77v-1.79c0-.59-.27-.87-.74-.87s-.86.33-.86,1v1.68h-.77v-1.79c0-.59-.28-.87-.75-.87s-.85.33-.85,1v1.68h-.78V380h.74v.42a1.36,1.36,0,0,1,1.08-.46,1.24,1.24,0,0,1,1.11.55,1.55,1.55,0,0,1,1.24-.55A1.27,1.27,0,0,1,337.08,381.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.19,381.94H338.6a1,1,0,0,0,1.07.79,1.21,1.21,0,0,0,.9-.36l.41.47a1.65,1.65,0,0,1-1.33.54,1.68,1.68,0,0,1-1.82-1.69,1.64,1.64,0,0,1,1.7-1.69,1.61,1.61,0,0,1,1.67,1.71A1.93,1.93,0,0,1,341.19,381.94Zm-2.6-.52h1.88a.9.9,0,0,0-.94-.8A.92.92,0,0,0,338.59,381.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46,381.45v1.89h-.77v-1.79c0-.59-.27-.87-.74-.87s-.86.33-.86,1v1.68h-.77v-1.79c0-.59-.27-.87-.74-.87s-.86.33-.86,1v1.68h-.78V380h.74v.42a1.36,1.36,0,0,1,1.08-.46,1.23,1.23,0,0,1,1.11.55,1.55,1.55,0,0,1,1.24-.55A1.27,1.27,0,0,1,347.46,381.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,381.69a1.61,1.61,0,0,1-1.68,1.69,1.34,1.34,0,0,1-1.09-.47v.43h-.74v-4.59h.78v1.69a1.34,1.34,0,0,1,1-.44A1.6,1.6,0,0,1,352,381.69Zm-.79,0a1,1,0,0,0-1-1,1,1,0,0,0,0,2.06A1,1,0,0,0,351.17,381.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.78,381.94h-2.59a1,1,0,0,0,1.07.79,1.21,1.21,0,0,0,.9-.36l.41.47a1.64,1.64,0,0,1-1.33.54,1.68,1.68,0,0,1-1.82-1.69,1.64,1.64,0,0,1,1.71-1.69,1.61,1.61,0,0,1,1.66,1.71A1.93,1.93,0,0,1,355.78,381.94Zm-2.59-.52h1.87a.95.95,0,0,0-1.87,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.45,380v.74a.62.62,0,0,0-.18,0,.9.9,0,0,0-1,1v1.6h-.77V380h.73v.48A1.3,1.3,0,0,1,358.45,380Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.36,381.45v1.89h-.78v-1.79c0-.59-.27-.87-.74-.87s-.86.33-.86,1v1.68h-.77v-1.79c0-.59-.27-.87-.74-.87s-.86.33-.86,1v1.68h-.77V380h.73v.42a1.36,1.36,0,0,1,1.08-.46,1.24,1.24,0,0,1,1.12.55A1.53,1.53,0,0,1,365,380,1.27,1.27,0,0,1,366.36,381.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.47,381.94h-2.59a1,1,0,0,0,1.07.79,1.17,1.17,0,0,0,.89-.36l.42.47a1.65,1.65,0,0,1-1.33.54,1.68,1.68,0,0,1-1.83-1.69,1.65,1.65,0,0,1,1.71-1.69,1.62,1.62,0,0,1,1.67,1.71C370.48,381.77,370.47,381.86,370.47,381.94Zm-2.6-.52h1.87a.89.89,0,0,0-.93-.8A.91.91,0,0,0,367.87,381.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,379.69V381h2.09v.68H394v1.66h-.8V379h3.16v.68Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.67,381.69a1.76,1.76,0,1,1,1.75,1.69A1.66,1.66,0,0,1,396.67,381.69Zm2.73,0a1,1,0,1,0-1,1A1,1,0,0,0,399.4,381.69Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.83,380v.74l-.18,0a.9.9,0,0,0-.95,1v1.6h-.78V380h.74v.48A1.3,1.3,0,0,1,402.83,380Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,380v2.8a1.55,1.55,0,0,1-1.78,1.74,2.6,2.6,0,0,1-1.6-.47l.34-.58a2,2,0,0,0,1.22.4c.73,0,1-.34,1-1v-.18a1.44,1.44,0,0,1-1.11.44,1.6,1.6,0,1,1,0-3.19,1.43,1.43,0,0,1,1.15.48V380Zm-.76,1.55a1,1,0,0,0-2,0,1,1,0,0,0,2,0Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.47,381.69a1.76,1.76,0,1,1,1.76,1.69A1.67,1.67,0,0,1,407.47,381.69Zm2.74,0a1,1,0,1,0-1,1A1,1,0,0,0,410.21,381.69Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.72,383.16a1.23,1.23,0,0,1-.75.22,1,1,0,0,1-1.13-1.11v-1.59h-.55v-.62h.55v-.75h.77v.75h.88v.62h-.88v1.57c0,.32.16.5.46.5a.71.71,0,0,0,.43-.14Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.75,380.55c0,.95-.7,1.54-1.84,1.54h-1v1.25h-.81V379h1.78C419.05,379,419.75,379.59,419.75,380.55Zm-.81,0c0-.54-.36-.86-1.06-.86h-.94v1.72h.94C418.58,381.41,418.94,381.1,418.94,380.55Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.22,381.4v1.94h-.73v-.4a1.19,1.19,0,0,1-1,.44c-.76,0-1.23-.41-1.23-1s.37-1,1.37-1h.85v-.05c0-.45-.27-.71-.82-.71a1.66,1.66,0,0,0-1,.32l-.3-.56a2.31,2.31,0,0,1,1.39-.41C422.67,380,423.22,380.45,423.22,381.4Zm-.78.91v-.39h-.79c-.53,0-.67.2-.67.44s.23.46.63.46A.83.83,0,0,0,422.44,382.31Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.83,383l.29-.59a2.16,2.16,0,0,0,1.15.33c.49,0,.7-.13.7-.36,0-.63-2,0-2-1.36,0-.62.56-1,1.45-1a2.57,2.57,0,0,1,1.23.29l-.29.58a1.86,1.86,0,0,0-.95-.24c-.47,0-.69.15-.69.37,0,.66,2,.07,2,1.36,0,.62-.57,1-1.5,1A2.58,2.58,0,0,1,423.83,383Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,383l.3-.59a2.13,2.13,0,0,0,1.15.33c.48,0,.69-.13.69-.36,0-.63-2,0-2-1.36,0-.62.56-1,1.45-1a2.64,2.64,0,0,1,1.24.29l-.3.58a1.86,1.86,0,0,0-.95-.24c-.46,0-.69.15-.69.37,0,.66,2,.07,2,1.36,0,.62-.57,1-1.49,1A2.64,2.64,0,0,1,427,383Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.66,380l-1.22,3.3h-.74l-.86-2.27-.86,2.27h-.74L430,380h.73l.87,2.43.91-2.43h.64l.89,2.45L435,380Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.82,381.69a1.76,1.76,0,1,1,1.76,1.69A1.66,1.66,0,0,1,435.82,381.69Zm2.74,0a1,1,0,1,0-1,1A1,1,0,0,0,438.56,381.69Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,380v.74l-.18,0a.9.9,0,0,0-1,1v1.6h-.77V380h.74v.48A1.3,1.3,0,0,1,442,380Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.85,378.75v4.59h-.74v-.43a1.36,1.36,0,0,1-1.1.47,1.69,1.69,0,0,1,0-3.38,1.31,1.31,0,0,1,1.06.45v-1.7Zm-.76,2.94a1,1,0,1,0-1,1A1,1,0,0,0,445.09,381.69Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.76,380.2c0-.35-.3-.58-.77-.58a1.15,1.15,0,0,0-1,.48l-.6-.39a2,2,0,0,1,1.67-.76c.91,0,1.52.42,1.52,1.13,0,1-1.06,1.1-1.06,1.83h-.78C447.73,381,448.76,380.82,448.76,380.2Zm-1.13,2.7a.49.49,0,0,1,1,0,.49.49,0,0,1-1,0Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.43,382.3a.36.36,0,0,1-.24-.09l-1-.8a.37.37,0,0,1,0-.52.37.37,0,0,1,.53-.06l.7.58,1.67-1.81a.37.37,0,0,1,.53,0,.38.38,0,0,1,0,.53l-1.91,2.08A.36.36,0,0,1,315.43,382.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.09,287.42a2.9,2.9,0,0,0,1.71-2.66,2.7,2.7,0,1,0-5.39,0,2.86,2.86,0,0,0,1.72,2.68c-4.15.62-4,5.13-4,5.13l9.8.05S442.2,288,438.09,287.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.19,256.21h2.3v6.31h3.88v1.82h-6.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.75,261.18a3.57,3.57,0,1,1,3.55,3.27A3.29,3.29,0,0,1,369.75,261.18Zm4.88,0a1.33,1.33,0,1,0-2.65,0,1.34,1.34,0,1,0,2.65,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.65,258.05v5.14c0,2.38-1.35,3.51-3.69,3.51a5.6,5.6,0,0,1-3.13-.82l.8-1.55a3.67,3.67,0,0,0,2.13.67c1.18,0,1.68-.53,1.68-1.52v-.21a2.35,2.35,0,0,1-1.87.75,3,3,0,1,1,0-6.08,2.28,2.28,0,0,1,2,.88v-.77ZM382.47,261a1.38,1.38,0,0,0-2.76,0,1.38,1.38,0,0,0,2.76,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55,256.21h2.3v8.13h-2.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08,260.74v3.6h-2.21V261.1c0-.9-.39-1.29-1-1.29s-1.25.45-1.25,1.49v3h-2.21v-6.29h2.1v.68a2.72,2.72,0,0,1,2-.79A2.47,2.47,0,0,1,400.08,260.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.15,166.08H555.62a1.18,1.18,0,0,1-1.18-1.18v-8.22a1.18,1.18,0,0,1,1.17-1.18h16.54a.29.29,0,0,1,.21.09.27.27,0,0,1,.09.21v2.71h1.77a.3.3,0,0,1,.3.3v4a.3.3,0,0,1-.3.3h-1.77v2.71A.3.3,0,0,1,572.15,166.08Zm-.31-10H555.61a.57.57,0,0,0-.57.58v8.22a.58.58,0,0,0,.58.58h16.22v-2.71a.3.3,0,0,1,.31-.3h1.76v-3.36h-1.76a.3.3,0,0,1-.31-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.39,163.12v-4.66a1,1,0,0,1,1-1h7.77a1,1,0,0,1,1,1v4.66a1,1,0,0,1-1,1H557.4A1,1,0,0,1,556.39,163.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.3,
    y: 412.2,
    width: 86.22,
    height: 7.38,
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.05,
    y: 412.2,
    width: 1.47,
    height: 7.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.96,
    y: 412.2,
    width: 1.47,
    height: 7.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.29,
    y: 412.2,
    width: 1.47,
    height: 7.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.2,
    y: 412.2,
    width: 1.47,
    height: 7.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553,417.92s.1,0,.29,0a1.36,1.36,0,0,0,.71-.41,1.34,1.34,0,0,0,.31-.52,1.64,1.64,0,0,0,0-.74,1.31,1.31,0,0,0-.38-.76,1.42,1.42,0,0,0-.87-.4H541.19l-39.38,0a1.34,1.34,0,0,0-1.33,1.29,1.57,1.57,0,0,0,.1.68,1.35,1.35,0,0,0,1,.79,5.4,5.4,0,0,0,.7,0H536.7l11.94,0h0l-11.94,0L519,418H502.31a4.36,4.36,0,0,1-.72,0,1.44,1.44,0,0,1-1.12-.86,1.68,1.68,0,0,1-.12-.73,1.47,1.47,0,0,1,1.46-1.42l39.38,0,11.94,0a1.49,1.49,0,0,1,.9.42,1.43,1.43,0,0,1,.38.79,1.68,1.68,0,0,1-.06.75,1.32,1.32,0,0,1-.32.53,1.34,1.34,0,0,1-.73.4l-.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.52,
    y: 419.5,
    width: 80.05,
    height: 10.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.52,
    y: 420.8,
    width: 80.05,
    height: 7.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.88,421s-17.65.07-39.4.07-39.4,0-39.4-.07,17.64-.06,39.4-.06S567.88,421,567.88,421Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.88,423.25s-17.65.07-39.4.07-39.4,0-39.4-.07,17.64-.06,39.4-.06S567.88,423.22,567.88,423.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.88,425.49s-17.65.07-39.4.07-39.4,0-39.4-.07,17.64-.06,39.4-.06S567.88,425.45,567.88,425.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.88,427.73s-17.65.06-39.4.06-39.4,0-39.4-.06,17.64-.06,39.4-.06S567.88,427.69,567.88,427.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.32,
    y: 390.51,
    width: 10.97,
    height: 20.79,
    transform: "translate(995.62 801.81) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.3,
    y: 389.78,
    width: 58.88,
    height: 22.55,
    transform: "translate(1065.48 802.1) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.46,412.32h13.25v-1.46H491.46a.73.73,0,0,0-.73.73h0A.73.73,0,0,0,491.46,412.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.46,391.24h13.25v-1.46H491.46a.73.73,0,0,0-.73.73h0A.73.73,0,0,0,491.46,391.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,393.3s2.46.06,5.49.06,5.49,0,5.49-.06-2.46-.07-5.49-.07S492.32,393.26,492.32,393.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,396s2.46.07,5.49.07,5.49,0,5.49-.07-2.46-.06-5.49-.06S492.32,395.93,492.32,396Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,398.63s2.46.06,5.49.06,5.49,0,5.49-.06-2.46-.06-5.49-.06S492.32,398.6,492.32,398.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,401.3s2.46.06,5.49.06,5.49,0,5.49-.06-2.46-.06-5.49-.06S492.32,401.26,492.32,401.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,404s2.46.06,5.49.06,5.49,0,5.49-.06-2.46-.07-5.49-.07S492.32,403.93,492.32,404Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,406.63s2.46.06,5.49.06,5.49,0,5.49-.06-2.46-.06-5.49-.06S492.32,406.6,492.32,406.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,409.3s2.46.06,5.49.06,5.49,0,5.49-.06-2.46-.06-5.49-.06S492.32,409.26,492.32,409.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.77,
    y: 399.14,
    width: 43.09,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.43,237.47c-11.75,6.09-20.76,16.57-27.24,28.11s-10.65,24.2-14.79,36.77l-3.62,64.84c13.67-23.27,24.65-50.61,27.61-77.43l-9.1-.81c6.11-.93,11.23-5.35,14.49-10.6s4.93-11.28,6.57-17.23l-11.1,1.65A41.13,41.13,0,0,0,717.43,237.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717.43,237.47c-11.75,6.09-20.76,16.57-27.24,28.11s-10.65,24.2-14.79,36.77l-3.62,64.84c13.67-23.27,24.65-50.61,27.61-77.43l-9.1-.81c6.11-.93,11.23-5.35,14.49-10.6s4.93-11.28,6.57-17.23l-11.1,1.65A41.13,41.13,0,0,0,717.43,237.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M669.76,382.38s-29.68-35.53-29.34-69.44h12s-13-8.56-12-13.36,1.37-22.95,1.37-22.95l11,2.74s-8.22-4.11-9.25-10.62,2.4-36.65,2.4-36.65,13.36,14.05,17.47,28.43,14.9,31.17,11.73,75S669.76,382.38,669.76,382.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.8,385.73S717,364.31,724.1,337l-9.64-2.62s12.34-4,12.57-8.12,3.91-18.75,3.91-18.75l-9.41-.2s7.51-1.5,9.76-6.51,6.09-30,6.09-30-13.81,8.37-20.26,19-18.8,21.8-25.85,57.74S684.8,385.73,684.8,385.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654,263.07a2.63,2.63,0,0,1,.1.37c.07.28.15.64.26,1.1l.94,4.21c.41,1.83.89,4.08,1.4,6.69s1.15,5.58,1.75,8.88c1.27,6.59,2.61,14.47,4,23.23s2.67,18.42,3.86,28.59,2.06,19.88,2.76,28.72,1.15,16.82,1.42,23.53c.16,3.35.24,6.38.33,9s.13,5,.15,6.83,0,3.3,0,4.32v1.12a1.65,1.65,0,0,1,0,.39,1.88,1.88,0,0,1,0-.38c0-.28,0-.65-.05-1.13,0-1-.09-2.46-.15-4.31s-.13-4.17-.25-6.83-.21-5.69-.4-9c-.32-6.69-.85-14.66-1.53-23.5s-1.64-18.54-2.8-28.7-2.51-19.82-3.82-28.58-2.65-16.64-3.88-23.23c-.57-3.3-1.16-6.28-1.66-8.89s-.94-4.87-1.32-6.71l-.84-4.23c-.09-.47-.16-.83-.21-1.11A2,2,0,0,1,654,263.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.64,404.13s-27.16-30.82-35.59-49.44l6.36-2.72c-4.61.76-9.34-1.23-12.92-4.24s-6.2-7-8.78-10.88l8.39-1.41a31.19,31.19,0,0,1-18.33-14.2c9.9,1.63,18.85,7.07,26.23,13.86,6,5.5,11,11.89,15.89,18.42a62.86,62.86,0,0,1,6.18,10.14C657.63,373.1,665.65,392.81,665.64,404.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.53,288.72a1.91,1.91,0,0,1-.13.31c-.11.23-.24.52-.42.89-.39.82-1,2-1.65,3.42-1.46,3-3.53,7.26-6,12.6s-5.39,11.74-8.49,18.89-6.34,15.09-9.59,23.47-6.15,16.46-8.7,23.83-4.69,14.05-6.43,19.68-3.11,10.21-4,13.37c-.46,1.56-.82,2.78-1.07,3.65-.12.39-.22.7-.29.94a1.72,1.72,0,0,1-.12.32,1.34,1.34,0,0,1,.06-.33c.07-.25.15-.56.25-1l1-3.67c.85-3.19,2.16-7.78,3.86-13.42s3.83-12.35,6.33-19.74,5.42-15.45,8.66-23.86,6.54-16.31,9.64-23.47,6-13.54,8.59-18.86,4.66-9.6,6.17-12.53l1.75-3.37c.19-.37.35-.65.46-.87S724.52,288.71,724.53,288.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.94,417.34a3.2,3.2,0,0,1-.12-.57l-.27-1.64c-.1-.71-.23-1.58-.42-2.58s-.35-2.16-.63-3.41c-.48-2.52-1.18-5.5-2.07-8.78s-2-6.83-3.42-10.5-2.9-7.08-4.37-10.14-2.95-5.74-4.25-8c-.63-1.12-1.25-2.1-1.78-3s-1-1.62-1.39-2.22l-.89-1.4a4.05,4.05,0,0,1-.28-.51s.14.14.37.45.57.8,1,1.34.92,1.32,1.47,2.18,1.2,1.83,1.85,2.94c1.34,2.2,2.83,4.89,4.36,7.94s3,6.49,4.43,10.17,2.5,7.26,3.39,10.55,1.53,6.3,2,8.84c.25,1.26.4,2.42.56,3.43s.26,1.89.34,2.61.12,1.21.16,1.65A2.33,2.33,0,0,1,667.94,417.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.34,
    y: 410.09,
    width: 59.44,
    height: 12.13,
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "650 422.21 656.43 459.08 692.35 459.08 698.34 422.21 650 422.21",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.13,422.21c0,.15-11.24.26-25.11.26s-25.11-.11-25.11-.26S661.15,422,675,422,700.13,422.07,700.13,422.21Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 423.56 56.12 459.05 87.5 459.05 94.78 424.07 50.72 423.56",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,446.31c0,.1-8,.18-18,.18s-18-.08-18-.18,8-.19,18-.19S90.4,446.2,90.4,446.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.52,444.56c0,.1-8.1.18-18.08.18s-18.08-.08-18.08-.18,8.09-.18,18.08-.18S90.52,444.46,90.52,444.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.46,442.59c0,.1-8.1.18-18.08.18s-18.09-.08-18.09-.18,8.1-.19,18.09-.19S90.46,442.49,90.46,442.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.72,457a57.24,57.24,0,0,1-1.56-9,28.3,28.3,0,0,1,1,4.47A27.28,27.28,0,0,1,59.72,457Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,456.65a32.2,32.2,0,0,1-.39-4.36,33.11,33.11,0,0,1-.2-4.37,22.4,22.4,0,0,1,.57,4.35A21.37,21.37,0,0,1,61.86,456.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75,456.65a21.53,21.53,0,0,1-.82-4.47,23.11,23.11,0,0,1-.24-4.54,36.25,36.25,0,0,1,.61,4.5A39.59,39.59,0,0,1,65.75,456.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.48,456.84a22.46,22.46,0,0,1-.43-4.55,21.6,21.6,0,0,1,.14-4.56,40.69,40.69,0,0,1,.22,4.55A38,38,0,0,1,68.48,456.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.32,456.65a24.51,24.51,0,0,1-.33-4.31A26.46,26.46,0,0,1,73,448a24.56,24.56,0,0,1,.33,4.32A25,25,0,0,1,73.32,456.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.85,456.84a53.86,53.86,0,0,1,.07-8.92,53.86,53.86,0,0,1-.07,8.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.16,456.36a30,30,0,0,1,.27-4.66,30.32,30.32,0,0,1,.63-4.62,30,30,0,0,1-.27,4.66A30.32,30.32,0,0,1,80.16,456.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.43,455.9a15.38,15.38,0,0,1,.53-4,16.21,16.21,0,0,1,1.16-3.82,35.29,35.29,0,0,1-.8,3.9A36.46,36.46,0,0,1,84.43,455.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41,353.51s0,.06,0,.18l-.15.5-.59,1.91c-.27.83-.59,1.85-.93,3s-.75,2.54-1.13,4.05-.83,3.15-1.22,4.94-.8,3.7-1.21,5.72c-.75,4-1.44,8.52-1.92,13.24s-.67,9.26-.74,13.37c0,2.06,0,4,.06,5.85s.13,3.53.22,5.08.22,3,.31,4.19.2,2.3.3,3.16.16,1.51.21,2l0,.52v.18s0-.06,0-.18,0-.3-.08-.51c-.07-.49-.16-1.15-.28-2s-.25-1.92-.36-3.16-.28-2.63-.37-4.19-.22-3.26-.27-5.09-.08-3.8-.09-5.86c0-4.13.25-8.66.71-13.4s1.18-9.22,2-13.28c.41-2,.79-3.94,1.24-5.72s.86-3.44,1.27-4.94.83-2.85,1.19-4,.69-2.2,1-3l.66-1.9c.08-.19.13-.36.18-.49S81.4,353.51,81.41,353.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,375.49a11.68,11.68,0,0,1,4.88-6.16,2.82,2.82,0,0,1,2.58-.48c1.1.53,1.19,2.07.86,3.25a8.62,8.62,0,0,1-3.55,4.84,7.26,7.26,0,0,1-5.33,1.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.84,390.33c.81-3.06,3.25-7.42,5.79-9.31a3.58,3.58,0,0,1,1.32-.7,1.5,1.5,0,0,1,1.4.3,2.16,2.16,0,0,1,.32,2,12.35,12.35,0,0,1-9.16,9.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.31,403.4a18,18,0,0,1,5.84-7.35,2.8,2.8,0,0,1,2-.73c1.11.2,1.62,1.56,1.52,2.68-.2,2.31-2,4.16-3.79,5.6a23.32,23.32,0,0,1-5.41,2.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.61,412.79a17.13,17.13,0,0,1,5-5.66,3.53,3.53,0,0,1,1.49-.67,1.52,1.52,0,0,1,1.46.56c.5.73,0,1.72-.51,2.43a14.17,14.17,0,0,1-7.09,5.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36,409a55.36,55.36,0,0,0-7.11-7.25c-.4-.34-.91-.7-1.42-.53a1,1,0,0,0-.65.95,2.62,2.62,0,0,0,.27,1.19,13.81,13.81,0,0,0,9.16,7.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.59,396.75,68,389.94a6.88,6.88,0,0,0-1.81-1.72,2.27,2.27,0,0,0-2.38,0,2.24,2.24,0,0,0-.77,2.24,5.85,5.85,0,0,0,1.09,2.24A16.63,16.63,0,0,0,68.2,397c1.64,1.12,3.13,1.86,5.1,1.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.36,383a19.41,19.41,0,0,0-5.62-8.44,3.33,3.33,0,0,0-1.46-.85,2.46,2.46,0,0,0-2.56,1.8,4.6,4.6,0,0,0,.51,3.7A9.59,9.59,0,0,0,67.85,382a22.3,22.3,0,0,0,6.22,3.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,370.72c-.55-3.94-2.6-7.23-5-10.42-.5-.68-1.2-1.39-2-1.26a1.6,1.6,0,0,0-1.17,1,3.63,3.63,0,0,0-.22,1.57,12.18,12.18,0,0,0,7.91,10.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.16,364.46a32.77,32.77,0,0,1-.21-6.1,11,11,0,0,1,2-5.69,4.78,4.78,0,0,1,2-1.62,2.57,2.57,0,0,1,2.49.33,2.72,2.72,0,0,1,.85,2.19,6.9,6.9,0,0,1-.63,2.34c-1.49,3.58-4,7.55-6.56,8.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.82,369.16a1.66,1.66,0,0,1,0,.5c0,.37,0,.84,0,1.44s0,1.38,0,2.26,0,1.89.1,3c.1,2.22.32,4.86.65,7.78s.86,6.11,1.55,9.43,1.53,6.44,2.37,9.25,1.73,5.31,2.53,7.38c.38,1.05.78,2,1.11,2.79s.63,1.52.88,2.09.41,1,.56,1.32a3.14,3.14,0,0,1,.17.47,3.06,3.06,0,0,1-.24-.44L63,415.14c-.28-.56-.6-1.25-.94-2.07s-.76-1.73-1.16-2.77c-.84-2.07-1.73-4.57-2.61-7.38s-1.7-5.95-2.41-9.28-1.18-6.54-1.52-9.46-.51-5.58-.58-7.81c0-1.11,0-2.12,0-3s0-1.65,0-2.27,0-1.07.05-1.44A4.16,4.16,0,0,1,53.82,369.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,385.35a8.36,8.36,0,0,1,2-5.25,2,2,0,0,1,1.66-.88c.86.13,1.25,1.16,1.28,2a6.12,6.12,0,0,1-1.38,4.06,5.15,5.15,0,0,1-3.33,2.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,395.86a14,14,0,0,1,1.93-7.59,2.71,2.71,0,0,1,.75-.76,1.11,1.11,0,0,1,1-.09,1.53,1.53,0,0,1,.65,1.31A8.83,8.83,0,0,1,56.71,397",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.05,404.87a12.71,12.71,0,0,1,2.4-6.26,1.93,1.93,0,0,1,1.23-.93c.8-.11,1.43.71,1.61,1.49.36,1.62-.45,3.26-1.38,4.63a16.62,16.62,0,0,1-3.08,3.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,411.2a12.4,12.4,0,0,1,2.17-4.92,2.59,2.59,0,0,1,.87-.78,1.07,1.07,0,0,1,1.12.07c.49.39.38,1.16.17,1.76a10.11,10.11,0,0,1-3.71,5.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.28,408.66a38.44,38.44,0,0,0-6.4-3.4,1.13,1.13,0,0,0-1.08-.06.76.76,0,0,0-.23.79,2,2,0,0,0,.44.75A9.82,9.82,0,0,0,60.9,410",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,400.29l-5.27-3.44a4.91,4.91,0,0,0-1.61-.78,1.62,1.62,0,0,0-1.62.5,1.58,1.58,0,0,0,0,1.69,4.17,4.17,0,0,0,1.22,1.29,12,12,0,0,0,3.71,2.07,4.89,4.89,0,0,0,3.81,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.38,390.75a13.89,13.89,0,0,0-5.65-4.53,2.23,2.23,0,0,0-1.18-.27,1.76,1.76,0,0,0-1.36,1.78,3.28,3.28,0,0,0,1.15,2.4,6.89,6.89,0,0,0,2.38,1.33,16.45,16.45,0,0,0,5,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.25,381.92a16.19,16.19,0,0,0-5.63-6c-.49-.35-1.12-.69-1.65-.42a1.12,1.12,0,0,0-.58.93,2.55,2.55,0,0,0,.19,1.12,8.71,8.71,0,0,0,7.73,5.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,377.32a23.16,23.16,0,0,1-1.45-4.12,7.76,7.76,0,0,1,.15-4.3,3.36,3.36,0,0,1,1-1.54,1.82,1.82,0,0,1,1.76-.31,1.91,1.91,0,0,1,1.05,1.31,4.78,4.78,0,0,1,.08,1.73c-.25,2.75-1.08,6-2.63,7.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5,368.82a2.42,2.42,0,0,1,0,.5c0,.36,0,.84.06,1.43s0,1.39,0,2.27,0,1.89-.06,3c-.06,2.22-.25,4.87-.57,7.8s-.83,6.14-1.52,9.47-1.55,6.46-2.41,9.28-1.78,5.31-2.61,7.38c-.4,1-.82,2-1.16,2.77s-.67,1.51-.94,2.07-.47,1-.62,1.29a4,4,0,0,1-.24.44,1.51,1.51,0,0,1,.17-.47l.56-1.32c.25-.57.55-1.27.88-2.09s.72-1.74,1.1-2.79c.81-2.07,1.67-4.58,2.53-7.38s1.67-5.94,2.38-9.26,1.18-6.51,1.54-9.43.55-5.55.65-7.77c.07-1.11.08-2.12.11-3s0-1.65,0-2.27,0-1.07,0-1.43A3.21,3.21,0,0,1,93.5,368.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.63,385a8.27,8.27,0,0,0-2-5.24,2,2,0,0,0-1.65-.88c-.86.12-1.26,1.15-1.29,2A6.12,6.12,0,0,0,89.07,385,5.16,5.16,0,0,0,92.41,387",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.73,395.52a14,14,0,0,0-1.94-7.59,2.59,2.59,0,0,0-.75-.76,1.07,1.07,0,0,0-1-.1,1.56,1.56,0,0,0-.65,1.32,8.85,8.85,0,0,0,4.25,8.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,404.53a12.91,12.91,0,0,0-2.4-6.26,2,2,0,0,0-1.23-.94c-.8-.1-1.44.71-1.61,1.5-.36,1.62.44,3.26,1.37,4.63a17,17,0,0,0,3.09,3.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,410.86a12.42,12.42,0,0,0-2.16-4.93,2.6,2.6,0,0,0-.88-.77,1.08,1.08,0,0,0-1.11.06c-.5.39-.39,1.17-.18,1.76a10.11,10.11,0,0,0,3.71,5.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,408.31a40.41,40.41,0,0,1,6.4-3.4,1.16,1.16,0,0,1,1.08-.06.75.75,0,0,1,.24.79,1.84,1.84,0,0,1-.44.75,9.84,9.84,0,0,1-7.89,3.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52,399.94l5.27-3.43a4.67,4.67,0,0,1,1.6-.78,1.45,1.45,0,0,1,1.67,2.19,4.32,4.32,0,0,1-1.23,1.29,11.62,11.62,0,0,1-3.7,2.06,4.85,4.85,0,0,1-3.81,0",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,390.41a14,14,0,0,1,5.64-4.54,2.38,2.38,0,0,1,1.19-.26,1.75,1.75,0,0,1,1.35,1.77A3.29,3.29,0,0,1,99,389.79a7.2,7.2,0,0,1-2.39,1.33,16,16,0,0,1-4.95.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.07,381.57a16.32,16.32,0,0,1,5.63-6,1.74,1.74,0,0,1,1.66-.43,1.18,1.18,0,0,1,.58.94,2.7,2.7,0,0,1-.19,1.12A8.7,8.7,0,0,1,93,382.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.36,377a23.35,23.35,0,0,0,1.45-4.11,7.79,7.79,0,0,0-.16-4.31,3.29,3.29,0,0,0-1-1.53,1.82,1.82,0,0,0-1.77-.31,2,2,0,0,0-1,1.3,5,5,0,0,0-.07,1.73c.24,2.76,1.08,6,2.63,7.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,416.53v6.64a2.61,2.61,0,0,0,2.61,2.61H95.18a2.61,2.61,0,0,0,2.61-2.61v-6.64Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "51.06 425.78 51.43 427.9 93.37 430.89 94.43 425.78 51.06 425.78"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.71,224.65l-6.7-2c-8.11-2.83-14.82-.65-19.21,4.83s-6.09,12.75-5.84,19.77c.16,4.52,1,9.28-.79,13.42a23.91,23.91,0,0,1-4.45,6.07,17.79,17.79,0,0,0-4.1,6.29c-.75,2.41-.38,5.33,1.54,7a14.59,14.59,0,0,1,2.49,2c.9,1.16.82,2.78.91,4.25a15.5,15.5,0,0,0,29.73,5.19c2-4.59,1.6-9.78,1.4-14.76A192.65,192.65,0,0,1,164.71,224.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.25,216.48c-5.8-1.72-11.27-.06-16.66,2.67A29.86,29.86,0,0,0,150,231.81a29.51,29.51,0,0,0-3.32,18.47A23.64,23.64,0,0,0,156.51,266c7.23,4.83,17.23,4.65,24.74.27s12.48-12.52,13.85-21.1a28.79,28.79,0,0,0-2.49-17.5,21.87,21.87,0,0,0-13.36-11.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,234.58c1.13-2.16,1.1-4.73,1.73-7.09,1.39-5.19,6.15-8.91,11.32-10.38,4.81-1.37,10.35-.28,15.66,2.16a21.28,21.28,0,0,1,9.09,7.61,16.69,16.69,0,0,1,1.26,15.27L172.52,235c-2.78,1.79-5.63,3.61-8.84,4.41a5.6,5.6,0,0,1-2.87.11,2.52,2.52,0,0,1-1.9-2C158.79,236.45,159.51,235.52,160,234.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.4,226.8,164.21,229a4.41,4.41,0,0,0-4.63,3.82l-5.84,51.1a16,16,0,0,0,2.17,10l1.9,3.17c4.34,7.23,14.82,7.81,19.62.88a5.55,5.55,0,0,0,.7-1.27,8.07,8.07,0,0,0,.36-1.13l1-4.92c.78-4.52,1.36-9.14,1.36-9.1s9.8-.06,13.77-12.21c2-6,3.28-16.25,4.08-24.63C199.47,237.16,196,227.2,188.4,226.8Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,254.83a1.61,1.61,0,0,1-1.8,1.36,1.54,1.54,0,0,1-1.42-1.7,1.62,1.62,0,0,1,1.8-1.37A1.57,1.57,0,0,1,194.18,254.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.7,249.65c-.23.18-1.3-.91-3-1.18s-3.12.39-3.27.15.18-.45.8-.77a4.42,4.42,0,0,1,2.66-.37,4.18,4.18,0,0,1,2.36,1.2C195.69,249.17,195.81,249.57,195.7,249.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.84,253a1.62,1.62,0,0,1-1.8,1.37,1.54,1.54,0,0,1-1.41-1.7,1.62,1.62,0,0,1,1.79-1.37A1.54,1.54,0,0,1,178.84,253Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.34,247.26c-.23.18-1.3-.91-3-1.18s-3.11.39-3.27.15.19-.45.8-.76a4.36,4.36,0,0,1,2.66-.38,4.18,4.18,0,0,1,2.36,1.2C179.34,246.78,179.46,247.18,179.34,247.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,261a12.16,12.16,0,0,1,2.88,0c.44,0,.87,0,1-.29a2.22,2.22,0,0,0-.08-1.35c-.25-1.13-.5-2.31-.77-3.55-1-5.05-1.72-9.17-1.52-9.21s1.22,4,2.26,9.07c.25,1.24.48,2.43.71,3.56a2.55,2.55,0,0,1,0,1.76,1.11,1.11,0,0,1-.82.53,3.18,3.18,0,0,1-.77,0A11,11,0,0,1,183,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,281.56a32,32,0,0,1-16-7.11s2.82,9.3,15.48,10.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,265.05a3.12,3.12,0,0,0-2.59-1.59,2.84,2.84,0,0,0-2.12.74,1.8,1.8,0,0,0-.46,2,2.08,2.08,0,0,0,2.16.93,6.59,6.59,0,0,0,2.41-1,1.86,1.86,0,0,0,.57-.43.57.57,0,0,0,.1-.64",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,261.41c.28,0,0,1.89,1.38,3.47s3.4,1.69,3.38,2-.5.29-1.35.18a4.74,4.74,0,0,1-2.84-1.53,4.11,4.11,0,0,1-1-2.89C177.29,261.81,177.58,261.38,177.7,261.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,241.19c-.25.44-1.93-.06-4-.13s-3.77.21-4-.25c-.09-.22.26-.62,1-1a6.75,6.75,0,0,1,3.07-.55,6.59,6.59,0,0,1,3,.85C180.53,240.55,180.84,241,180.74,241.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.19,242.13c-.36.34-1.48-.26-2.9-.5s-2.68-.16-2.89-.61c-.09-.22.16-.58.75-.87a4.25,4.25,0,0,1,4.66.9C197.25,241.53,197.36,242,197.19,242.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.12,230.42c3.31-6.89,15.16-15.41,22.64-13.82l11.05,8.92a11.77,11.77,0,0,1-9.15,7.8c-2.22.35-4.81.17-6.34,1.83s-1.18,4.52-2.66,6.28c-2,2.45-6.59,1.68-8.25,4.4-.72,1.19-.65,2.74-1.39,3.91-1,1.57-5.53,3.1-7.2,2.3s-1.26-3.79-1.61-5.43a8.33,8.33,0,0,1,.52-5.58C155,237.61,154.54,233.71,156.12,230.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.78,254.24c.14-.93.33-2.26-.51-2.68-2.51-1.26-7.79-2.18-8.82,4-1.41,8.49,7.4,8.15,7.45,7.91S159.28,257.44,159.78,254.24Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,259.85s-.16.08-.43.16a1.56,1.56,0,0,1-1.11-.16c-.84-.48-1.36-2-1.15-3.57a5.15,5.15,0,0,1,.77-2,1.77,1.77,0,0,1,1.3-.95.78.78,0,0,1,.81.55c.07.26,0,.42,0,.44s.21-.11.2-.47a1,1,0,0,0-.25-.59,1.14,1.14,0,0,0-.78-.35,2.11,2.11,0,0,0-1.76,1.06,5.06,5.06,0,0,0-.91,2.28c-.23,1.72.38,3.46,1.55,4a1.58,1.58,0,0,0,1.39,0C155.8,260.06,155.87,259.87,155.84,259.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.64,222.65c.37,3.56,5.11,8.65,7.11,11.63,3.8,5.7,4.47,7.51,3,19.05,2.57-3.74,4.63-7.45,5-12a18.77,18.77,0,0,0-3.47-12.82,14.58,14.58,0,0,0-11.69-5.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,228.22c4.85-7,11-10.71,16.55-11.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,261.09a2.25,2.25,0,0,1-.35-.39,12.1,12.1,0,0,1-.9-1.25,18.61,18.61,0,0,1-2.25-5.17,34.2,34.2,0,0,1-1.06-8.3,24.82,24.82,0,0,1,1.8-10.06,35.44,35.44,0,0,1,5-9,32.59,32.59,0,0,1,5.87-6,24,24,0,0,1,4.85-2.88c.61-.26,1.09-.45,1.43-.56a1.85,1.85,0,0,1,.51-.14s-.67.31-1.85.89a26.07,26.07,0,0,0-4.71,3,33.55,33.55,0,0,0-5.72,6A35.63,35.63,0,0,0,149,236.1a24.7,24.7,0,0,0-1.81,9.87,35.43,35.43,0,0,0,.94,8.22,20,20,0,0,0,2.06,5.16C150.88,260.49,151.35,261.06,151.3,261.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.21,370.06S243,364.53,251,363.18c15.26-2.59,30.52-.12,37,13,2.95,6-.79,17.49-9.73,26-6.68,6.38-39.81,39.89-39.81,39.89l-28.39-23.71,35.14-27.33-68.12,9.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.83,425.74,226.56,445s13.81,25.34,10.79,29.24L198,439.61l27.21-31.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.87,432.63a2.1,2.1,0,0,0-2.7.82,2.06,2.06,0,0,0,.84,2.69,2.21,2.21,0,0,0,2.85-.89,2.13,2.13,0,0,0-1.18-2.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,439.61l2.75-3.16,36.91,34.62a4.33,4.33,0,0,1-.3,3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.38,445.39c-.18.18-1.21-.58-2.69-.8s-2.69.12-2.8-.11,1.14-1.07,2.93-.76S227.57,445.25,227.38,445.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,450.71c-.12.22-1.24-.2-2.59,0s-2.29.9-2.48.72.64-1.35,2.33-1.59S230.18,450.52,230,450.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.1,457.63c-.21-.12.35-1.3,1.75-1.9s2.67-.22,2.61,0-1.1.3-2.24.81S228.3,457.78,228.1,457.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,440.53c-.23.1-.88-.94-2-1.83s-2.3-1.29-2.25-1.54,1.45-.21,2.79.85S231.27,440.46,231,440.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,422.38a2.47,2.47,0,0,1-.36.43L256.57,424l-4.07,4.22-13.86,14.1-.17.17-.18-.15-3.54-3-17.53-14.73L212,420.1l-1.42-1.25a3.57,3.57,0,0,1-.47-.46,3.29,3.29,0,0,1,.54.38l1.48,1.17,5.38,4.39,17.62,14.61,3.54,3-.35,0,14-14,4.18-4.1,1.15-1.09A2.25,2.25,0,0,1,258,422.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.55,420.83l24,21.14,23.78,11.27a3.27,3.27,0,0,1,1.46,4.55h0a3.26,3.26,0,0,1-2.5,1.66c-6.72.72-31.46,3.23-33.13,1.58-1.93-1.9-26.76-20.63-26.76-20.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.76,457.79l-37.28,1.85,1.65,1.39a3.3,3.3,0,0,0,2.59.65c3.13,0,11.78-.25,30.48-2.15a3.3,3.3,0,0,0,2.56-1.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.47,450.52a2,2,0,0,1,2.33,1.26,1.9,1.9,0,0,1-1.22,2.31,2.08,2.08,0,0,1-2.46-1.33,2,2,0,0,1,1.54-2.28",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.37,454.38c.18-.08-.63-1.71-.1-3.74s2-3.11,1.84-3.27-.5.08-1.06.58a5.21,5.21,0,0,0-1.34,5.43C333,454.09,333.3,454.43,333.37,454.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,455.4c.2,0,.07-1.48.77-3s1.83-2.48,1.71-2.65-1.58.57-2.35,2.37S337.94,455.47,338.11,455.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.44,454.09c.22,0,0-2.25.88-4.79s2.37-4.19,2.21-4.34-2,1.38-2.88,4.12S326.28,454.15,326.44,454.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.62,448.27c.2.06.77-1.77,2.19-3.58s3-2.85,2.91-3-2,.64-3.46,2.6S318.44,448.25,318.62,448.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.27,444.52c.21,0,.54-2,2.19-3.79s3.61-2.35,3.54-2.55-.55-.08-1.35.21a7.17,7.17,0,0,0-4.3,4.76C313.14,444,313.19,444.51,313.27,444.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.33,391.76c.49,1.22-1.67,40.45,35.56,40.69,33.42.22,78.37-30.41,83.5-28.45,3.35,1.29,61,51.4,61,51.4L317.25,431S263.87,380,258.62,376.35c-11.24-7.86-19.14-7.8-37.63-4.45-16.55,3-57.08,16.45-57.08,16.45L160,385Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,375.85s.21-.1.63-.26l1.86-.7c1.65-.59,4.09-1.43,7.3-2.33a91,91,0,0,1,11.87-2.51,48.89,48.89,0,0,1,7.58-.52,38.65,38.65,0,0,1,8.45,1.07,40.87,40.87,0,0,1,17.27,8.92c5.15,4.8,10.52,10.05,16.25,15.51l37.24,35.74.17.17-.16.19c-.9,1.07-1.88,2.22-2.87,3.37-3.08,3.63-6.28,7.32-9.45,10.72s-6,6.82-8.94,10.2l.08.18-32.69-28.27c-4.95-4.3-9.64-8.35-14-12.13l-6.3-5.45c-1-.88-2-1.73-3-2.56-.48-.42-.95-.85-1.44-1.21a8.36,8.36,0,0,0-1.56-.89,8,8,0,0,0-6.59.11l-5.51,2.7-8.79,4.31-5.52,2.69-1.43.68-.5.22s.16-.1.47-.26l1.42-.73,5.48-2.76,8.75-4.38,5.5-2.74a8.31,8.31,0,0,1,8.48.78c.52.38,1,.8,1.47,1.21l3,2.55,6.32,5.43,14,12.09,32.74,28.22.09.17c2.88-3.42,5.87-6.94,8.75-10.57s5.71-7.09,8.78-10.69l2.83-3.33,0,.36-37.21-35.78c-5.72-5.47-11.09-10.74-16.2-15.53A40.69,40.69,0,0,0,246.59,371a39.3,39.3,0,0,0-8.38-1.1,48.62,48.62,0,0,0-7.53.49,91.89,91.89,0,0,0-11.86,2.41c-3.21.87-5.66,1.68-7.31,2.24l-1.88.65C209.2,375.79,209,375.85,209,375.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.57,288.78s12.35,4.9,13.81,15.34c1.22,8.7-1.49,31.88-1.45,33.45a5.49,5.49,0,0,0,1.31,3.75,8.71,8.71,0,0,1,2.33,6,9.39,9.39,0,0,1-.76,4.34c-1.41,2.38-15.07,18.2-15.07,18.2L176.6,344.59s8-23.66,8-24.27S188.57,288.78,188.57,288.78Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.55,350.59c.52.07,18.33,12.72,18.33,12.72s4.35-8.4,6.3-8.65,7.95,2.06,8.48,2.69,1.7.74,2.88.85,3.26,3.06,3.26,3.06l4,3s-1.26,2.34-1.59,2.74-3-.72-3-1.15.34,2.63-1.74,2.72a11.66,11.66,0,0,1-4.76-1.32l-.7-3.53-5.16-3.36-.62,3.39s5.23,1.07,5.06,2.79a2.63,2.63,0,0,1-1.69,2.22l-4.32-.09-9.51,2.28s-24.94-5.52-25.85-8.35S195.24,349.6,202.55,350.59Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.73,344.68a17.42,17.42,0,0,1,4.93,6.85c1.1,2.53,13,11.23,13,11.23L211,370.57s-20.12.83-21.06-2.16,2.2-16.33,2.2-16.33Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.19,378.63h0a1.71,1.71,0,0,0,2,1.22l35-7.65,30.06-5.47.25-2.67-28.72,4.12-37.31,8.34A1.71,1.71,0,0,0,190.19,378.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,327.05l-16.17,41.4a2.29,2.29,0,0,0,2.5,3.09l35.7-6.59a2.27,2.27,0,0,0,1.75-1.43l16.22-41.07a1.22,1.22,0,0,0-1.23-1.66l-36.83,4.82A2.28,2.28,0,0,0,244.84,327.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.49,325.61c.14.06-3.74,10.36-8.65,23s-9,22.89-9.14,22.84,3.74-10.36,8.66-23S248.36,325.56,248.49,325.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43,345.19c-1,2-.94,4.06.15,4.61s2.78-.63,3.78-2.63.95-4.06-.14-4.6S258.44,343.19,257.43,345.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.78,372.19s-2.92-12.27-2.33-14.52c1.68-6.47,10.33-22.8,9.61-32.58s-9.49-36.31-9.49-36.31l-8.36-2.91c-3.38,7.37-16.5,5.72-27.21-2.91l-13.42,2.72-21,65.38L115,374.88c-8.52,11.11,1.3,17,1.3,17s16.18,5.1,29,2.81c9.57-1.7,23.53-8.46,26.66-10.91,7.49-5.87,19.37-5.46,19.37-5.46Z",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.3,372.79l8.76,3.58s4.87-2.9,5.58-3.17A104.88,104.88,0,0,1,194,371.68a24.13,24.13,0,0,0,4.06-.25l-11.57,7.12-7.33,9.76a22.12,22.12,0,0,1-6.24,1.09c-3.22,0-10.82-1.84-10.82-1.84Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.26,285.48s-15.37.91-20.78,13.18c-3.61,8.18-11,44.22-12.14,50.81s0,14.62,5.28,18.78,49.07,22.81,49.07,22.81l9.13-17.59-36.94-22.94h-1.2l4.42-26.47",
    style: {
      fill: "#041147"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,324.05s0,.15,0,.46l-.21,1.34c-.19,1.2-.46,2.95-.82,5.2-.75,4.56-1.82,11.18-3.18,19.49l-.16-.18h1.25l0,0,37,22.88.19.12-.1.19c-2.9,5.6-5.95,11.5-9.12,17.6l-.1.21-.22-.1c-8.89-3.79-18.36-7.92-28.06-12.31q-5.76-2.61-11.32-5.27c-1.84-.9-3.67-1.8-5.46-2.74a23.54,23.54,0,0,1-5.11-3.25,14.32,14.32,0,0,1-3.33-5,20.56,20.56,0,0,1-1.43-5.66,28,28,0,0,1,0-5.71c.18-1.88.57-3.69.9-5.49,1.4-7.16,2.86-13.94,4.28-20.28s2.84-12.22,4.28-17.55c.72-2.66,1.46-5.19,2.27-7.55a22,22,0,0,1,3.35-6.19,22.43,22.43,0,0,1,4.51-4.14,26.52,26.52,0,0,1,4.53-2.45,31.27,31.27,0,0,1,6.83-2c.8-.13,1.42-.2,1.83-.24a5,5,0,0,1,.63,0l-.62.08c-.42.06-1,.15-1.83.3a31.9,31.9,0,0,0-6.76,2.08,26.17,26.17,0,0,0-4.47,2.46,22.26,22.26,0,0,0-4.42,4.12,21.63,21.63,0,0,0-3.27,6.12c-.79,2.35-1.52,4.87-2.22,7.54-1.42,5.33-2.81,11.21-4.21,17.55s-2.85,13.11-4.24,20.27c-.32,1.8-.71,3.61-.88,5.45a26.23,26.23,0,0,0,0,5.6c.43,3.72,1.76,7.59,4.61,10.3a23.6,23.6,0,0,0,5,3.17c1.78.93,3.61,1.83,5.45,2.72q5.55,2.65,11.3,5.26c9.7,4.39,19.17,8.52,28,12.33l-.32.12,9.14-17.59.08.31-36.89-23,.08,0-1.2,0h-.19l0-.19L136.85,331c.39-2.25.7-4,.91-5.19.1-.57.18-1,.24-1.33S138.1,324.05,138.1,324.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.73,304.11c.05,0-.21.93-.39,2.61a23.73,23.73,0,0,0-.1,3.07c0,1.2.19,2.56.4,4.07a87.28,87.28,0,0,1,1.09,10.63,33,33,0,0,1-2.06,12.92c-1.69,4.35-3.9,8.21-5.27,11.95a25,25,0,0,0-1.09,10.45c.19,3,.47,5.47.65,7.16.08.8.14,1.45.19,1.94a3.57,3.57,0,0,1,0,.69,2.93,2.93,0,0,1-.14-.67c-.08-.5-.17-1.14-.3-1.94-.23-1.68-.57-4.12-.81-7.16a25,25,0,0,1,1-10.63c1.37-3.81,3.57-7.68,5.24-12a33.34,33.34,0,0,0,2.06-12.73,92.05,92.05,0,0,0-1-10.6c-.18-1.51-.3-2.89-.32-4.1a19.82,19.82,0,0,1,.19-3.11,15.68,15.68,0,0,1,.38-1.92A3.21,3.21,0,0,1,196.73,304.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.46,311.21c-.1,0,.38-1.39.63-3.66a20.93,20.93,0,0,0,.06-4,24,24,0,0,0-.94-4.8,22.92,22.92,0,0,0-4.27-7.77c-1.47-1.75-2.6-2.64-2.53-2.72a3.8,3.8,0,0,1,.82.58,16.14,16.14,0,0,1,2,1.9,21.49,21.49,0,0,1,4.49,7.85,23.2,23.2,0,0,1,.92,4.93,19.4,19.4,0,0,1-.17,4.08,13.36,13.36,0,0,1-.3,1.55,7.5,7.5,0,0,1-.33,1.13A4.14,4.14,0,0,1,142.46,311.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76,347.81a23,23,0,0,0,4.16-1.62,18.71,18.71,0,0,0,1.9-1.22,24.28,24.28,0,0,0,1.94-1.71,23.72,23.72,0,0,0,3.65-4.65,31.72,31.72,0,0,0,3.89-10c.52-2.73.56-4.46.67-4.45a6,6,0,0,1,0,1.21,26,26,0,0,1-.33,3.31,29.24,29.24,0,0,1-3.81,10.23,22.13,22.13,0,0,1-3.76,4.73,21.62,21.62,0,0,1-2,1.71,17.21,17.21,0,0,1-2,1.19,11.2,11.2,0,0,1-1.75.75,8.51,8.51,0,0,1-1.38.39A6.63,6.63,0,0,1,163.76,347.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,355.32a12.32,12.32,0,0,1,5-3.6,12.53,12.53,0,0,1,6-1.26,37.18,37.18,0,0,0-5.81,1.74A37,37,0,0,0,124,355.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,373.74a1.57,1.57,0,0,1-1.19,1.29,1.75,1.75,0,0,1-.4,0c-1,0-1.41-1.79-1.41-1.79l-4.34.59s-6.2,7.86-8.39,10.09c-8.61,8.78-10.85,2.44-10.85,2.44l2.66-10.31,5.51-9.22s-.35.56-.22-.89,2.68-1.7,2.68-1.7c.17-.75,1.67-1.45,1.67-1.45l6.91-1.28a4.79,4.79,0,0,1,4,1.08l4.19,3.6s2.48,2.76,2.47,3.59a1.4,1.4,0,0,1-1.29,1.35s.32,2.22-.21,2.46a4.9,4.9,0,0,1-1.78.11Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.15,371.76c0,.07.89-.29,2.34-.66a21,21,0,0,1,5.76-.65,20.53,20.53,0,0,1,3.18.34c.94.21,1.9.32,2.34.83a.84.84,0,0,1,.17.82,1.2,1.2,0,0,1-.38.58c-.3.25-.56.22-.55.27s.26.12.66-.13a1.25,1.25,0,0,0,.5-.64,1.08,1.08,0,0,0-.16-1.09,2.2,2.2,0,0,0-1.12-.69c-.43-.13-.89-.25-1.38-.35a18.4,18.4,0,0,0-9.11.41A8.26,8.26,0,0,0,184.15,371.76Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,376.16c0,.12,2.73-.82,6.13-1.65s6.21-1.24,6.19-1.37a7,7,0,0,0-1.87.11,39.39,39.39,0,0,0-4.43.83,40.83,40.83,0,0,0-4.31,1.31A7.25,7.25,0,0,0,185,376.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.21,373.58a3.1,3.1,0,0,0-.13-.74,17.29,17.29,0,0,0-.6-1.95,8.22,8.22,0,0,0-.6-1.3,4.17,4.17,0,0,0-1.1-1.25,9.48,9.48,0,0,0-3.29-1.8,13,13,0,0,0-3.68-.63,11.63,11.63,0,0,0-3,.44c-.84.22-1.5.45-1.95.6a2.49,2.49,0,0,0-.69.29,23.25,23.25,0,0,0,2.71-.58,12.64,12.64,0,0,1,2.94-.34,13.24,13.24,0,0,1,3.56.65,9.51,9.51,0,0,1,3.17,1.69,5.29,5.29,0,0,1,1.66,2.35C199.85,372.57,200.12,373.61,200.21,373.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86,364.42c0,.07,1-.21,2.68-.52s4.1-.87,6.15.82a23.76,23.76,0,0,1,5,4.2,14.7,14.7,0,0,1,1.4,2.31,2.11,2.11,0,0,0-.18-.72,7,7,0,0,0-1-1.78,20.74,20.74,0,0,0-5-4.38,7.79,7.79,0,0,0-1.7-.92,5,5,0,0,0-1.8-.25,14.88,14.88,0,0,0-3,.41A10.83,10.83,0,0,0,186.86,364.42Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,380a3.82,3.82,0,0,0,.3-.43l.85-1.24a47.08,47.08,0,0,1,3.46-4.36l-.09,0,4.35-.56-.2-.13a4.33,4.33,0,0,0,.39,1,2,2,0,0,0,.77.85,1.16,1.16,0,0,0,.63.08,1.59,1.59,0,0,0,.59-.14,1.8,1.8,0,0,0,.85-.89,1.33,1.33,0,0,0,.11-.3v-.13h0l-.22.17h.16q.3,0,.6,0t.6,0a1.83,1.83,0,0,0,.32-.07.67.67,0,0,0,.36-.19,1.27,1.27,0,0,0,.24-.67,4.43,4.43,0,0,0,0-.63,10.51,10.51,0,0,0-.09-1.25l-.19.24a1.64,1.64,0,0,0,1.38-1,1.32,1.32,0,0,0,0-.92,5.29,5.29,0,0,0-.39-.75,23.15,23.15,0,0,0-2.05-2.62h0L199,364.14l-1.42-1.22a9,9,0,0,0-1.49-1.14,4.86,4.86,0,0,0-1.81-.54,6,6,0,0,0-1.81.17L186,362.63h0a5.2,5.2,0,0,0-1,.63,1.89,1.89,0,0,0-.76,1l.21-.14a2.42,2.42,0,0,0-2.11.77,2.85,2.85,0,0,0-.54,2l0-.1-3.81,6.32-1,1.74a3.81,3.81,0,0,0-.33.62,3,3,0,0,0,.41-.58l1.09-1.68L182,367l0,0v-.06a2.49,2.49,0,0,1,.49-1.76,2,2,0,0,1,1.78-.63l.17,0,0-.16a1.66,1.66,0,0,1,.62-.75,6.51,6.51,0,0,1,.95-.58l0,0,6.52-1.18a5.74,5.74,0,0,1,1.69-.16,4.16,4.16,0,0,1,1.64.49,8.22,8.22,0,0,1,1.41,1.09l1.42,1.22L201,366.4l0,0a23.75,23.75,0,0,1,2,2.56,3.59,3.59,0,0,1,.35.67.89.89,0,0,1,0,.62,1.19,1.19,0,0,1-1,.73l-.22,0,0,.21a9.69,9.69,0,0,1,.09,1.2,2,2,0,0,1-.15,1,.48.48,0,0,1-.17.07,1.09,1.09,0,0,1-.26.05,3.38,3.38,0,0,1-.55,0,3.62,3.62,0,0,1-.57,0h-.15c.2-.14-.26.2-.21.17h0v0l0,.07a.9.9,0,0,1-.08.23,1.37,1.37,0,0,1-.66.7,1.2,1.2,0,0,1-.46.11.68.68,0,0,1-.43,0,2.71,2.71,0,0,1-1-1.59l0-.15-.15,0-4.34.62h-.06l0,0a42.45,42.45,0,0,0-3.38,4.47c-.35.55-.61,1-.78,1.29A2.79,2.79,0,0,0,188.46,380Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.61,328.81a31.67,31.67,0,0,1-4.17,10.44c-2.39,3.66-5.38,5.59-9.1,7.88l-.28.11a14.08,14.08,0,0,0,13.55-18.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerloginPana1);
export default __webpack_public_path__ + "static/media/Computer login-pana(1).b5352971c8cc9bd6ec5d9db1a9cc1412.svg";
export { ForwardRef as ReactComponent };